import React from 'react';
import PropTypes from 'prop-types';

const Card = ({ type, small, special, card, openModal }) => {
  // small can be 0, 1 or 2. When small === 0 we don't add className 'small' (1/3 probability). When small === 1 we add className 'top'. When small === 2 we add className 'bottom'
  let cardClasses = 'card';
  if (small === 0) {
    cardClasses = `${cardClasses} ${type}`;
  } else if (small === 1) {
    cardClasses = `${cardClasses} ${type} small top`;
  } else if (small === 2) {
    cardClasses = `${cardClasses} ${type} small bottom`;
  }
  if (special) {
    cardClasses = `${cardClasses} special`;
  }

  let flowerSizeClass = 'flower-size';

  const formattedTitle = (title) => {
    const result = title.split(' ');
    if (result.length === 1) {
      return <span>{result[0]}</span>;
    } else if (
      result.length === 2 &&
      result[0].length < 6 &&
      result[1].length < 6
    ) {
      return <span>{title}</span>;
    } else {
      flowerSizeClass = 'flower-size left';
      return (
        <span className="splitted">
          <span>{result[0]}</span>
          <span>{result.slice(1).join(' ')}</span>
        </span>
      );
    }
  };
  return (
    <section className="card-wrapper">
      <div className={cardClasses}>
        <div className="card-content">
          <div className="flower-data">
            <h3 className="flower-title">{formattedTitle(`${card.title}`)}</h3>
            <div className={flowerSizeClass}>
              <div className="size-data">
                <span className="top-size">
                  <svg width="26px" height="24px">
                    <use href="#flower-top"></use>
                  </svg>
                </span>
                <div>{card.topSize} см</div>
              </div>
              <div className="size-data">
                <span className="bottom-size">
                  <svg width="31px" height="22px">
                    <use href="#flower-bottom"></use>
                  </svg>
                </span>
                <div>{card.bottomSize} см</div>
              </div>
            </div>
          </div>
          <img className="flower-image" src={card.image} alt="" />
          <div className="flower-price">
            150<span>&#8381;</span>
          </div>
        </div>
      </div>
    </section>
  );
};

Card.propTypes = {
  type: PropTypes.string.isRequired,
  small: PropTypes.number,
  special: PropTypes.bool,
  card: PropTypes.object,
};

export default Card;
